import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../constants";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`
  };
};
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: getHeaders()
});
// axiosInstance.interceptors.response.use(error => {
//   if (error && error.response && error.response.data)
//     toast.error(error.response.data.message);
//   return Promise.reject(error);
// });

export default axiosInstance;
